export const staffEarningsEn = {
  staffEarningsTitle: 'My earnings',
  staffEarningsListerIntro: 'Your earnings are calculated from collected plays using the percentage set by your banker.',
  staffEarningsRunnerIntro: 'Your earnings are calculated from completed collections using the percentage set by your banker.',
  agreementRequestChange: 'Request agreement review',
  agreementRequestHint: 'Explain why you want the agreement reviewed. Your banker alone sets the percentage.',
  agreementRequestReason: 'Reason for the request',
  agreementRequestReasonPlaceholder: 'Describe why you want your agreement reviewed…',
  agreementRequestSend: 'Send request',
  agreementRequestRemaining: '{count} of 2 requests remaining this quarter',
  agreementRequestLimitReached: 'You have used both agreement requests for this quarter.',
  agreementRequestHistory: 'Request history',
  agreementRequestPending: 'Pending banker review',
  agreementRequestApproved: 'Approved',
  agreementRequestRejected: 'Rejected',
  agreementRequestCurrentRate: 'Rate when requested',
  agreementRequestDecidedRate: 'Rate set by banker',
  agreementRequestReviewTitle: 'Agreement review request',
  agreementRequestReviewHint: 'Only the banker decides the new percentage. Approving updates the user agreement immediately.',
  agreementRequestNewRate: 'New percentage',
  agreementRequestReviewerNote: 'Note to the user (optional)',
  agreementRequestApprove: 'Approve and set percentage',
  agreementRequestReject: 'Reject request',
  agreementRequestNone: 'This user has no agreement review requests.',
} as const;

export const staffEarningsEs = {
  staffEarningsTitle: 'Mis ganancias',
  staffEarningsListerIntro: 'Tus ganancias se calculan sobre las jugadas recogidas usando el porcentaje establecido por tu banker.',
  staffEarningsRunnerIntro: 'Tus ganancias se calculan sobre las colectas completadas usando el porcentaje establecido por tu banker.',
  agreementRequestChange: 'Solicitar revisión del acuerdo',
  agreementRequestHint: 'Explica por qué deseas revisar el acuerdo. Solo tu banker establece el porcentaje.',
  agreementRequestReason: 'Motivo de la solicitud',
  agreementRequestReasonPlaceholder: 'Describe por qué deseas revisar tu acuerdo…',
  agreementRequestSend: 'Enviar solicitud',
  agreementRequestRemaining: 'Quedan {count} de 2 solicitudes este trimestre',
  agreementRequestLimitReached: 'Ya utilizaste las dos solicitudes de este trimestre.',
  agreementRequestHistory: 'Historial de solicitudes',
  agreementRequestPending: 'Pendiente de revisión del banker',
  agreementRequestApproved: 'Aprobada',
  agreementRequestRejected: 'Rechazada',
  agreementRequestCurrentRate: 'Porcentaje al solicitar',
  agreementRequestDecidedRate: 'Porcentaje establecido por el banker',
  agreementRequestReviewTitle: 'Solicitud de revisión del acuerdo',
  agreementRequestReviewHint: 'Solo el banker decide el nuevo porcentaje. Aprobar actualiza el acuerdo inmediatamente.',
  agreementRequestNewRate: 'Nuevo porcentaje',
  agreementRequestReviewerNote: 'Nota para el usuario (opcional)',
  agreementRequestApprove: 'Aprobar y establecer porcentaje',
  agreementRequestReject: 'Rechazar solicitud',
  agreementRequestNone: 'Este usuario no tiene solicitudes de revisión del acuerdo.',
} as const;
